import { render } from "./ServiceTypeLabel.vue?vue&type=template&id=35e7ffe9"
import script from "./ServiceTypeLabel.vue?vue&type=script&lang=js"
export * from "./ServiceTypeLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__